import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import BigCard from "../../../general/BigCard";
import styles from "./AmbientalL2.module.css";
import Leaflet from "./maps/LeafletMap";
import { AmbientalStore } from "./AmbientalStore";

function AmbientalL2({ distrito }) {
  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [areaMedia, setAreaMedia] = useState(null);
  const [numeroNascentes, setNumeroNascentes] = useState(null);

  const nascentesValue = AmbientalStore((state) => state.nascentesValue);

  const aguaCorrenteValue = AmbientalStore((state) => state.aguaCorrenteValue);

  const mataValue = AmbientalStore((state) => state.mataValue);

  const agrotoxicoValue = AmbientalStore((state) => state.agrotoxicoValue);

  const problemaSaudeAgrotoxicoValue = AmbientalStore(
    (state) => state.problemaSaudeAgrotoxicoValue
  );

  const setAmbientalMapImage = AmbientalStore((state) => state.setAmbientalMapImage);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [numeroPropriedades, areaMedia, numeroNascentes] =
          await Promise.all([
            Api.getNumeroPropriedadesAmbiental(
              distrito,
              nascentesValue,
              aguaCorrenteValue,
              mataValue,
              agrotoxicoValue,
              problemaSaudeAgrotoxicoValue
            ),
            Api.getAreaMediaAmbiental(
              distrito,
              nascentesValue,
              aguaCorrenteValue,
              mataValue,
              agrotoxicoValue,
              problemaSaudeAgrotoxicoValue
            ),
            Api.getNumeroNascentes(
              distrito,
              nascentesValue,
              aguaCorrenteValue,
              mataValue,
              agrotoxicoValue,
              problemaSaudeAgrotoxicoValue
            ),
          ]);
        setNumeroPropriedades(numeroPropriedades);
        setAreaMedia(areaMedia);
        setNumeroNascentes(numeroNascentes);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [
    distrito,
    nascentesValue,
    aguaCorrenteValue,
    mataValue,
    agrotoxicoValue,
    problemaSaudeAgrotoxicoValue,
  ]);

  return (
    <div className={styles.ambientalL2}>
      <div className={styles.cards}>
        <div className={styles.card}>
          <BigCard name="Propriedades" value={numeroPropriedades?.value} />
        </div>
        <div className={styles.card}>
          <BigCard
            name={
              <>
                Área Média
                <br />
                (ha)
              </>
            }
            value={areaMedia?.value?.toFixed(2)}
          />
        </div>
        <div className={styles.card}>
          <BigCard name="Nascentes" value={numeroNascentes?.value} />
        </div>
      </div>

      <div className={styles.map}>
        <Leaflet distrito={distrito} onImageReady={setAmbientalMapImage}/>
      </div>
    </div>
  );
}

export default AmbientalL2;
